module.exports = __webpack_public_path__ + "img/home.16f7dded.svg";